import { render, staticRenderFns } from "./EditElementRandomQuestion.vue?vue&type=template&id=4cc056a3"
import script from "./EditElementRandomQuestion.vue?vue&type=script&lang=js"
export * from "./EditElementRandomQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports